module.exports = __webpack_public_path__ + "static/media/8OLA10.781191c0.jpg";